import { create } from 'zustand';

export enum PerkFormMode {
  CREATE = 'perks-form:create',
  EDIT = 'perks-form:edit',
  VIEW = 'perks-form:view',
}

export enum PerkFormVariant {
  FORM_ONLY = 'perks-dialog:form-only',
  READ_ONLY = 'perks-dialog:read-only',
  READ_WITH_EDIT = 'perks-dialog:read-with-edit',
}

type StoreState = {
  close: () => void;
  formMode: PerkFormMode;
  isOpen: boolean;
  openCreate: () => void;
  openEdit: (id: string, step: number) => void;
  openViewLocked: (id: string) => void;
  openViewWithEdit: (id: string) => void;
  perkId: string;
  setFormVariant: (variant: PerkFormVariant) => void;
  step: number;
  variant: PerkFormVariant;
};

export const formStore = create<StoreState>()((set) => ({
  isOpen: false,
  formMode: PerkFormMode.CREATE,
  step: 0,
  variant: PerkFormVariant.FORM_ONLY,
  perkId: '',

  setFormVariant: (variant) => {
    set({ variant: variant });
  },

  openCreate: () => {
    set({
      isOpen: true,
      formMode: PerkFormMode.CREATE,
      variant: PerkFormVariant.FORM_ONLY,
      perkId: '',
    });
  },

  openViewLocked: (id) => {
    set({
      isOpen: true,
      formMode: PerkFormMode.VIEW,
      variant: PerkFormVariant.READ_ONLY,
      perkId: id,
    });
  },

  openViewWithEdit: (id) => {
    set({
      isOpen: true,
      formMode: PerkFormMode.EDIT,
      variant: PerkFormVariant.READ_WITH_EDIT,
      perkId: id,
    });
  },

  openEdit: (id, step) => {
    set({
      isOpen: true,
      formMode: PerkFormMode.EDIT,
      variant: PerkFormVariant.FORM_ONLY,
      perkId: id,
      step,
    });
  },

  close: () => {
    set({
      step: 0,
      isOpen: false,
      perkId: '',
    });
  },
}));
